export default {"src":"/_next/static/media/myanimelist.bd39201d.svg","height":800,"width":800,"blurWidth":0,"blurHeight":0};